import { useState } from "react";
import IToken from "../interfaces/token";

interface IUseToken {
  saveToken: (token: IToken) => void;
  token: IToken;
  callbackWithUrlToken: URL | null;
}

interface UseTokenProps {
  callbackUrl: string;
}

function useToken({ callbackUrl }: UseTokenProps): IUseToken {
  const [token, setToken] = useState<any>("{}");
  const [callbackWithUrlToken, setCallbackWithUrlToken] = useState<URL | null>(
    null
  );

  const saveToken = (userToken: IToken) => {
    const newCallbackUrl = new URL(callbackUrl);
    const stringToken = JSON.stringify(userToken.tokens);
    newCallbackUrl.searchParams.set("tokens", stringToken);
    setCallbackWithUrlToken(newCallbackUrl);
    setToken(userToken);
  };

  return {
    saveToken,
    token,
    callbackWithUrlToken,
  };
}

export default useToken;
